// src/pages/player/PlayerLayout.jsx
import React, { useContext } from 'react';
import { Outlet } from 'react-router-dom';
import PlayerSidebar from '../../components/Dashboard/Sidebar';
import { AuthContext } from '../../context/AuthContext';
import Swal from 'sweetalert2';

const PlayerLayout = () => {
    const { logout } = useContext(AuthContext);

    const handleLogout = () => {
        Swal.fire({
            title: 'Are you sure you want to log out?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, log out'
        }).then(async (result) => {
            if (result.isConfirmed) {
                await logout();
            }
        });
    };

    // By creating a layout component, we have a single place to manage the dashboard shell.
    // The <Outlet /> component from react-router-dom will render the specific child route component.
    return (
        <div className="flex bg-slate-100 min-h-screen">
            {/* The Sidebar now has its own logout logic passed via props or context */}
            <PlayerSidebar onLogout={handleLogout} />
            
            <main className="flex-grow p-8">
                {/* The Outlet will render the component for the matched sub-route, e.g., PlayerDashboard or PlayerProfile */}
                <Outlet />
            </main>
        </div>
    );
};

export default PlayerLayout;
